import * as React from "react";
import { forwardRef } from "react";
const SvgFlatPlus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#656975", d: "M12 15v-1h-1a1 1 0 0 1 0-2h1v-1a1 1 0 0 1 2 0v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0m-11.12.66A2.02 2.02 0 0 1 0 14V2a2.006 2.006 0 0 1 2-2h10a2.007 2.007 0 0 1 2 2v5a1 1 0 0 1-2 0V2H2v12l4.632-1.852a1 1 0 0 1 .743 1.856c-1.341.534-4.295 1.716-4.636 1.853-.236.092-.486.14-.739.143a2.04 2.04 0 0 1-1.12-.341z" }));
const ForwardRef = forwardRef(SvgFlatPlus);
export { ForwardRef as ReactComponent };
